import { render } from "./ResetAccount.vue?vue&type=template&id=4c772686"
import script from "./ResetAccount.vue?vue&type=script&lang=js"
export * from "./ResetAccount.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/my_res/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__